import cn from 'classnames';
import { Link as MuiLink } from "@mui/material";
import { Link } from 'react-router-dom';

import classes from './index.module.scss';

const InnerLink = ({ href, children, className, noUnderline = false, ...props }) => {
  return (
    <MuiLink
      component={Link}
      to={href}
      className={
        cn(
          className,
          {
            [ classes.noUnderline ]: !!noUnderline
          }
        )
      }
      {...props}
    >
      {children}
    </MuiLink>
  );
}

export default InnerLink;